import fetch from "@/uilts/request";

export default {
    async open(data) {
        return await fetch.post("DataNotary/open", data)
    },
    async createOrder(data) {
        return await fetch.post("DataNotary/createOrder", data)
    },
    async downloadQr(data) {
        return await fetch.post("DataNotary/downloadQr", data)
    },
    async getDetail(data) {
        return await fetch.post("DataNotary/getDetail", data)
    },
}
